import { render, staticRenderFns } from "./longStorageIncubationTest.vue?vue&type=template&id=18adee23&scoped=true&"
import script from "./longStorageIncubationTest.vue?vue&type=script&lang=js&"
export * from "./longStorageIncubationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18adee23",
  null
  
)

export default component.exports